$(document).ready(function(){
    $('.datepicker').datepicker({
        format: 'dd/mm/yyyy',
        autoclose: true
    });

    $('.dateranger').daterangepicker({
        autoUpdateInput: false,
        locale: {
            cancelLabel: 'Clear',
            format: 'DD/MM/YYYY'
        }
    });

    $('.dateranger').on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
    });

    $('.dateranger').on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
    });

    $('.daterange-btn').daterangepicker(
        {
            ranges   : {
                'This Week': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'This Quarter': [moment().startOf('quarter'), moment().endOf('quarter')],
                'This Year': [moment().startOf('year'), moment().endOf('year')]
            },
            startDate: moment().startOf('isoWeek'),
            endDate  : moment().endOf('isoWeek')
        },
        function (start, end) {
            $('#reportrange span').html(start.format('YYYY-MMMM-D') + ' - ' + end.format('YYYY-MMMM-D'))
        }
    )

    $('.daterange-btn-previous').daterangepicker(
        {
            ranges   : {
                'Last Week': [moment().subtract(1, 'week').startOf('isoWeek'), moment().subtract(1, 'week').endOf('isoWeek')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Last Quarter': [moment().subtract(1,'quarter').startOf('quarter'), moment().subtract(1,'quarter').endOf('quarter')],
                'Last Year': [moment().subtract(1,'year').startOf('year'), moment().subtract(1,'year').endOf('year')],
            },
            startDate: moment().subtract(1, 'week').startOf('isoWeek'),
            endDate  : moment().subtract(1, 'week').endOf('isoWeek')
            // for default custom range
            // startDate: moment().subtract(29, 'days'),
            // endDate  : moment()
        },
        function (start, end) {
            $('#reportrange span').html(start.format('YYYY-MMMM-D') + ' - ' + end.format('YYYY-MMMM-D'))
        }
    );

});

//databale

